module.exports = __webpack_public_path__ + "static/media/edit-blue.430a7007.svg";